import { gql } from '@apollo/client';
import { queryAllData } from 'services/query/residentContract';
import { queryResidentOccupancy } from './query/residentOccupancy';

export const GET_RESIDENT_CONTRACT = gql`
  query getResidentContractByResidentId($residentId: ID!) {
    getResidentContractByResidentId(residentId: $residentId) {
      ${queryAllData}
    }
  }
`;

export const GET_RESIDENT_OCCUPANCY = gql(`
  query GetResidentOccupancy($filter: FilterDateInput) {
    getResidentOccupancy(filter: $filter) {
      ${queryResidentOccupancy}
    }
  }
`);
